import {registerJQueryComponent} from '@lib/JQueryRegistry'

export default class MobileNavigationBar {
    constructor(rootElement) {
        this.$dom = {
            root: rootElement,
            drawerRoot: $('.mobile-drawer'),
            drawerOpenButton: rootElement.find('.navigation-bar-user-menu'),
            drawerCloseButton: $('.mobile-drawer').find('.mobile-drawer-close')
        }

        this.$dom.drawerOpenButton.click(this.onDrawerOpenButtonClick);
        this.$dom.drawerCloseButton.click(this.onDrawerCloseButtonClick);
    }

    onDrawerOpenButtonClick = () => {
        this.$dom.drawerRoot.addClass('mobile-drawer--visible');
    }

    onDrawerCloseButtonClick = () => {
        this.$dom.drawerRoot.removeClass('mobile-drawer--visible');
    }
}

registerJQueryComponent(MobileNavigationBar, '.navigation-bar-mobile')